import { useState } from 'react';
import { ItemDetailsResponse } from '../types';
import styles from '../item-details.module.scss';

type TraceView = 'request' | 'response';

interface Props {
  data: ItemDetailsResponse | null;
}

const ApiTraceTab: React.FC<Props> = ({ data }) => {
  const [activeView, setActiveView] = useState<TraceView>('request');

  if (!data) return null;

  const activeJson = activeView === 'request' ? data.apiRequest : data.apiResponse;

  return (
    <div className={styles.tabContent}>
      <div className={styles.pillToggle}>
        <button
          className={`${styles.pillOption} ${activeView === 'request' ? styles.pillOptionActive : ''}`}
          onClick={() => setActiveView('request')}
        >
          Request
        </button>
        <button
          className={`${styles.pillOption} ${activeView === 'response' ? styles.pillOptionActive : ''}`}
          onClick={() => setActiveView('response')}
        >
          Response
        </button>
      </div>

      <pre className={styles.traceJson}>
        {activeJson != null ? JSON.stringify(activeJson, null, 2) : '–'}
      </pre>
    </div>
  );
};

export default ApiTraceTab;
